module.exports = __webpack_public_path__ + "static/media/moonbeam.3d4db621.svg";